import { colors } from "components/Theme/WebTheme";
import {WEB_SECONDORY_COLOR,FONT_FAMILY} from "../../common/sharedFunctions";
const TableStyle = (settings) => {
    return {
        editable: {
            backgroundColor: colors.Header_Text,
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: FONT_FAMILY 
          },
          pageSize: 10,
          pageSizeOptions: [10, 15, 20, 50],
          // Mejoras globales para todas las tablas del panel:
          search: true,
          searchFieldAlignment: "right",
          filtering: true,
          exportButton: true,
          exportAllData: true,
          emptyRowsWhenPaging: false,
          draggable: false,
          headerStyle: {
            color: colors.Black,
            position: "sticky",
            top: "0px",
            backgroundColor:WEB_SECONDORY_COLOR(settings?.appCat),
            textAlign: "center",
            fontSize: "0.8em",
            fontWeight: "bold ",
            border: `1px solid ${colors.TABLE_BORDER}`,
            fontFamily: FONT_FAMILY 
          },
          cellStyle: {
            border: `1px solid ${colors.TABLE_BORDER}`,
            textAlign: "center",
          },
          actionsColumnIndex: -1,
        }
};

export default TableStyle;